<template lang="pug">
  p.form-control-static.text-prewrap {{value || app_lang.NO_INPUT}}
</template>

<script>
export default {
  name: 'MemoView',
  props: {
    value: { type: String, required: false, default: '' }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/molecules/MemoView.vue